import * as THREE from 'three'
import { gsap } from 'gsap'
import Experience from "../Experience";
import Environment from './Environment';

// Samples
import Floor from './Floor';

// Utils
import InteractionManager from '../Utils/InteractionManager';



// Planet
import Planet from './Planet/Planet';
import PlanetHighlight from './Planet/PlanetHighlights/PlanetHighlights'

// Bonfire Fire
import VolumetricFire from './Bonfire/Fire/VolumetricFire';

// .gltf Models
import Fox from './Fox';
import SpaceAmeCamping from './SpaceAmeCamping';
import AmeAndBonfire from './AmeAndBonfire';
import StarrySky from './StarrySky/StarrySky';
import BonfireSmoke from './Bonfire/Smoke/Smoke';

import ParticleText from './ParticleText/ParticleText';
import ParticleTextBright from './ParticleText/ParticleTextBright';

import ParticleImage from './ParticleImage/ParticleImage'
import ParticleImageBright from './ParticleImage/ParticleImageBright'
import ParticleThreeColorImage from './ParticleImage/ParticleThreeColorImage'

import ShootingStars from './ShootingStars/ShootingStars'
import Fireflies from './Fireflies/Fireflies'
import SceneDirector from './SceneDirector'
import OrbitingCelestials from './Celestials/OrbitingCelestials'

import LoadingScreen from '../LoadingScreen/LoadingScreen';

import AudioManager from '../Audio/AudioManager';

// TV
import TV from './TV/TV';
import TVModel from './TV/TVModel';

// インタラクトできる小物
import Lantern from './Lantern/Lantern';
import Signalscope from './Signalscope/Signalscope';

// 情景の飾りプロップ
import Satellite from './Satellite/Satellite';

// めくれる本
import Book from './Book/Book';


export default class World
{
  constructor()
  {
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.resources = this.experience.resources
    this.loadingScreen = this.experience.loadingScreen
    this.camera = this.experience.camera

    //TODO: Loading 関係なく表示したいものはスコープ外へ
    this.StarrySky = new StarrySky()
    // 流れ星はロード中から流れ出す（待ち時間のささやかなご褒美）
    this.shootingStars = new ShootingStars()

    /* SceneDirector は loadingScreen 'completed' を購読するため、
       イベント発火前（＝このコンストラクタ内）に生成しておく必要がある */
    this.sceneDirector = new SceneDirector()

    //TODO: Loading Screen のロード画面の処理が完了した生成してWorldを開始しよう
    this.loadingScreen.on('completed', () =>
    {
      // AudioManager
      this.audioManager = new AudioManager()
      this.experience.audioManager = this.audioManager

      // Setup
      /* NOTE: Environment のインスタンス生成時に、EnvironmentMap の影響を与える処理を今回は実装しているので、
            インスタンス化してSceneに追加する順序を、Environmentを最後にすること
      */
      // this.floor = new Floor()
      // this.fox = new Fox()
      // this.spaceAmeCamping = new SpaceAmeCamping()
      this.ameAndBonfire = new AmeAndBonfire()
      this.planet = new Planet()
      this.PlanetHighlight = new PlanetHighlight()




// Particle Text Instances
      // this.particleText = new ParticleText('Welcome', 30)
      this.particleTextBright = new ParticleTextBright('Created By HIRO', 40, 2, 0)
      this.particleTextBright.setSparkleSpeed(1.0)
      this.particleTextBright.setBrightnessRange(1.0, 1.5)
      this.particleTextBright.setScaleRange(1.5, 2.0)
      // this.particleTextBright.setParticleDensity(2)


// Particle Image Instances
      // this.particleImage = new ParticleImage('/image/bonfire_icon.png', 30, 3)

      this.particleImageBright = new ParticleImageBright('bonfireIcon', 30, 1, 0)
      this.particleImageBright.setSparkleSpeed(0.5)
      this.particleImageBright.setParticleDensity(2);
      // this.particleImageBright.setBrightnessRange(0.5, 0.8)
      // this.particleImage = new ParticleThreeColorImage('/image/bonfire_icon.png', 30, 5)

// 周回する天体（自己発光 ShaderMaterial。慣例に従い Environment より前に生成）
      this.orbitingCelestials = new OrbitingCelestials()

// TV Instance
      //NOTE: Environment 生成時の updateMaterial で envMapIntensity = 0 を受け取るため、Environment より前に生成すること
      this.tv = new TV()

      // ユーザーインタラクション後にビデオを再生
      setTimeout(() => {
        this.tv.play()
      }, 1000)

      // インスタンス化（loadingScreen完了後）
      // this.tvModel = new TVModel()
      // this.tvModel.setPosition(5, 0, 0) // 位置調整
      // this.tvModel.setScale(2) // サイズ調整

      //NOTE: いずれも MeshStandardMaterial を含むため Environment より前に生成すること
      this.lantern = new Lantern()
      this.signalscope = new Signalscope()
      this.satellite = new Satellite()
      this.book = new Book()

      this.environment = new Environment()
      //NOTE: smoke は shaderMaterial なので environment の影響は受けないはずなのでここで使用
      this.bonfireSmoke = new BonfireSmoke(this.environment);
      this.volumetricFire = new VolumetricFire(0.3, 1, 0.5, 0.1)
      this.volumetricFire.setPosition(-3.38, -0.5, 16.1)
      this.volumetricFire.setRotation(0, 0, -0.15)

      // 焚き火のまわりを漂う火の粉（ShaderMaterial なので Environment の影響を受けない）
      this.fireflies = new Fireflies()

// 空に浮かぶ文字をFadeIn・Out させる
      gsap.delayedCall(0.2, () => {
        gsap.to(this.particleTextBright.material.uniforms.textAlpha, { duration: 6.0, value: 1.0, ease: "power2.in", onComplete: () => {
        }})
        gsap.to(this.particleImageBright.material.uniforms.alpha, { duration: 2.0, value: 1.0, ease: "power2.in", onComplete: () => {
        }})
      })
    })
  }

  update()
  {
    //POINT: ロードが完了されてから update 実行すること
    if (this.fox)
    {
      this.fox.update()
    }

    // if (this.spaceAmeCamping)
    // {
    //   this.spaceAmeCamping.update()
    // }

    if (this.ameAndBonfire)
    {
      this.ameAndBonfire.update()
    }

    if (this.StarrySky)
    {
      this.StarrySky.update()
    }

    if (this.orbitingCelestials)
    {
      this.orbitingCelestials.update()
    }

    if (this.particleText)
    {
      this.particleText.update()
    }

    if (this.book)
    {
      this.book.update()
    }

    if (this.satellite)
    {
      this.satellite.update()
    }

    // TV: 電源 ON 中の動画テクスチャ更新（rVFC 非依存のフォールバック）
    if (this.tv)
    {
      this.tv.update()
    }
  }
}